/* Stealth Role Lab — progressive enhancement only.

   With this file blocked the section is still a complete, readable page: every
   question, every answer and every explanation is already in the HTML, and all
   three recommendations are visible as a short buyer's guide. Nothing here
   supplies content; it only adds selection, reveal and scoring on top.

   The class .js-lab is added to the section BEFORE anything is collapsed, so a
   failure to load leaves the content expanded rather than hidden. */
(function () {
  if (window.__stealthRoleLabInit) return;
  window.__stealthRoleLabInit = true;

  function init(root) {
    var questions = [].slice.call(root.querySelectorAll('[data-lab-q]'));
    var results = root.querySelector('[data-lab-results]');
    if (!questions.length) return;

    var grid = results && results.querySelector('.lab-results__grid');
    var resultsH = results && results.querySelector('[data-lab-results-h]');
    var resetBtn = results && results.querySelector('[data-lab-reset]');
    var baseHeading = resultsH ? resultsH.textContent : '';

    /* Declare the enhancement before collapsing anything. */
    root.classList.add('js-lab');

    function score() {
      var tally = {};
      var answered = 0;

      questions.forEach(function (q) {
        var picked = q.querySelector('.lab-a.is-picked');
        if (!picked) return;
        answered++;
        var m = picked.getAttribute('data-model');
        if (!m || m === 'none') return;
        tally[m] = (tally[m] || 0) + 1;
      });

      if (!grid) return;

      if (answered < questions.length) {
        grid.classList.remove('is-decided');
        [].forEach.call(grid.children, function (c) { c.classList.remove('is-match'); });
        if (resultsH) resultsH.textContent = baseHeading;
        if (resetBtn) resetBtn.hidden = answered === 0;
        return;
      }

      /* A stool answer is a statement about how someone works, not a
         preference, so it outranks a size answer when both are present. */
      var winner = null;
      if (tally.performer) winner = 'performer';
      else if (tally.pro) winner = 'pro';
      else if (tally.standard) winner = 'standard';

      grid.classList.add('is-decided');
      var matched = null;
      [].forEach.call(grid.children, function (c) {
        var is = c.getAttribute('data-lab-result') === winner;
        c.classList.toggle('is-match', is);
        if (is) matched = c;
      });

      if (resultsH && matched) {
        var name = matched.querySelector('.lab-result__h');
        resultsH.textContent = 'Your chair — ' + (name ? name.textContent.trim() : '');
      }
      if (resetBtn) resetBtn.hidden = false;

      /* Move focus to the recommendation so the outcome is announced rather
         than silently appearing further down the page. */
      if (matched && !matched.hasAttribute('tabindex')) matched.setAttribute('tabindex', '-1');
      if (matched) matched.focus({ preventScroll: true });
    }

    questions.forEach(function (q) {
      var answers = [].slice.call(q.querySelectorAll('[data-lab-a]'));
      answers.forEach(function (a) {
        var btn = a.querySelector('[data-lab-pick]');
        if (!btn) return;
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', function () {
          var already = a.classList.contains('is-picked');
          answers.forEach(function (other) {
            other.classList.remove('is-picked');
            var b = other.querySelector('[data-lab-pick]');
            if (b) b.setAttribute('aria-pressed', 'false');
          });
          if (!already) {
            a.classList.add('is-picked');
            btn.setAttribute('aria-pressed', 'true');
          }
          score();
        });
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        questions.forEach(function (q) {
          [].forEach.call(q.querySelectorAll('.lab-a'), function (a) {
            a.classList.remove('is-picked');
            var b = a.querySelector('[data-lab-pick]');
            if (b) b.setAttribute('aria-pressed', 'false');
          });
        });
        score();
        questions[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    score();
  }

  function boot() {
    document.querySelectorAll('[data-lab]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
